import { render, staticRenderFns } from "./RetirementFundAge.vue?vue&type=template&id=d4ecced0&scoped=true&"
import script from "./RetirementFundAge.vue?vue&type=script&lang=ts&"
export * from "./RetirementFundAge.vue?vue&type=script&lang=ts&"
import style0 from "./RetirementFundAge.vue?vue&type=style&index=0&id=d4ecced0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ecced0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VRow,VSlider})
